import React, { Component } from "react";
import fire from './fire';
import Carousel from 'react-bootstrap/lib/Carousel';
import "./App.css";

class App extends Component {
  render() {
    return (
      <div>
        <div id="header">
          <div className="logo">
            <span>Logo</span>
          </div>
          <div className="subtitle">
            <span>Tree & Farm Services in the Scottish Borders and beyond</span>
          </div>
        </div>
        <div id="welcome">
          <div className="title">
            <span>PROFESSIONAL SERVICE<br/>WHETHER MAJOR PROJECT<br/>OR GARDEN NECESSITY</span>
          </div>
          <Carousel controls={false} indicators={false} interval={3500}>
            <Carousel.Item>
              <picture>
                <source media="(max-width: 767px)" className="carouselimage" srcSet="images/welcome1-xs.jpg"/>
                <source media="(min-width: 768px)" className="carouselimage" srcSet="images/welcome1-sm.jpg"/>
                <source media="(min-width: 992px)" className="carouselimage" srcSet="images/welcome1-md.jpg"/>
                <source media="(min-width: 1200px)" className="carouselimage" srcSet="images/welcome1-lg.jpg"/>
                <img alt="1920x800" className="carouselimage" src="images/welcome1-lg.jpg" />
              </picture>
            </Carousel.Item>
            <Carousel.Item>
              <picture>
                <source media="(max-width: 767px)" className="carouselimage" srcSet="images/welcome2-xs.jpg"/>
                <source media="(min-width: 768px)" className="carouselimage" srcSet="images/welcome2-sm.jpg"/>
                <source media="(min-width: 992px)" className="carouselimage" srcSet="images/welcome2-md.jpg"/>
                <source media="(min-width: 1200px)" className="carouselimage" srcSet="images/welcome2-lg.jpg"/>
                <img alt="1920x800" className="carouselimage" src="images/welcome2-lg.jpg" />
              </picture>
            </Carousel.Item>
            <Carousel.Item>
              <picture>
                <source media="(max-width: 767px)" className="carouselimage" srcSet="images/welcome3-xs.jpg"/>
                <source media="(min-width: 768px)" className="carouselimage" srcSet="images/welcome3-sm.jpg"/>
                <source media="(min-width: 992px)" className="carouselimage" srcSet="images/welcome3-md.jpg"/>
                <source media="(min-width: 1200px)" className="carouselimage" srcSet="images/welcome3-lg.jpg"/>
                <img alt="1920x800" className="carouselimage" src="images/welcome3-lg.jpg" />
              </picture>
            </Carousel.Item>
          </Carousel>
        </div>
        <div id="services" className="container-fluid text-center">
          <h2>SERVICES</h2>
          <br/>
          <div className="row">
            <div className="col-sm-4">
              <img width={50} height={50} alt="50x50" src="images/service-tree.png" />
              <h4>Tree Work/Removal</h4>
            </div>
            <div className="col-sm-4">
              <img width={50} height={50} alt="50x50" src="images/service-hedge.png" />
              <h4>Hedge Cutting</h4>
            </div>
            <div className="col-sm-4">
              <img width={50} height={50} alt="50x50" src="images/service-garden.png" />
              <h4>Grass/Garden Maintenance</h4>
            </div>
          </div>
          <br/><br/>
          <div className="row">
            <div className="col-sm-4">
              <img width={50} height={50} alt="50x50" src="images/service-farmwork.png" />
              <h4>Farm Work</h4>
            </div>
            <div className="col-sm-4">
              <img width={50} height={50} alt="50x50" src="images/service-pressure.png" />
              <h4>Pressure Washing</h4>
            </div>
            <div className="col-sm-4">
              <img width={50} height={50} alt="50x50" src="images/service-other.png" />
              <h4>Many Others</h4>
            </div>
          </div>
        </div>
        <div id="gallery">
          <Carousel interval={null}>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/fences1.jpg" />
              <Carousel.Caption>
                <h3>Fencing</h3>
                <p>An example of our fencing</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/fences2.jpg" />
              <Carousel.Caption>
                <h3>Fencing</h3>
                <p>An example of our fencing</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/fences3.jpg" />
              <Carousel.Caption>
                <h3>Fencing</h3>
                <p>An example of our fencing</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/trees1.jpg" />
              <Carousel.Caption>
                <h3>Tree Work</h3>
                <p>An example of our tree work</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/pressure1.jpg" />
              <Carousel.Caption>
                <h3>Pressure Washing</h3>
                <p>This is before</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/pressure2.jpg" />
              <Carousel.Caption>
                <h3>Pressure Washing</h3>
                <p>This is after</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/turfing1.jpg" />
              <Carousel.Caption>
                <h3>Turfing</h3>
                <p>An example of our turfing</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/garden1.jpg" />
              <Carousel.Caption>
                <h3>Garden Maintenance</h3>
                <p>An example of our garden work</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/hedges1.jpg" />
              <Carousel.Caption>
                <h3>Hedging</h3>
                <p>An example of our hedging</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/hedges2.jpg" />
              <Carousel.Caption>
                <h3>Hedging</h3>
                <p>An example of our hedging</p>
              </Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img width={1920} height={800} alt="1920x800" src="images/hedges3.jpg" />
              <Carousel.Caption>
                <h3>Hedging</h3>
                <p>An example of our hedging</p>
              </Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>
        <div id="footer">
          <div className="title">
            <span>Contact us now for a quote or for more information<br/><br/>Tel: 0742 88 44 000<br/>Email: <a href="info@borderlandscaping.com">info@borderlandscaping.com</a></span>
          </div>
        </div>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js